<template>
    <div class="comContent">

        <div class="form-content">
            <el-form label-width="140px" :model="formTool" :rules="rules" ref="formTool"
                :disabled="isDisabled">
                <el-row>
                    <el-col :span="24" v-if="pageType=='edit'">
                        <el-form-item label="审核意见" prop="rejectReason" v-if="formTool.rejectReason && formTool.status == 'REJECT' ">
                            <div>
                                <el-input size="small" v-model="formTool.rejectReason"
                                    clearable show-word-limit maxlength="200" :rows="3" type="textarea"
                                    style="width: 450px;" />
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="活动名称" prop="promotionTitle">
                            <el-input v-model="formTool.promotionTitle" placeholder="请输入" size="small" clearable
                                style="width: 450px; margin-right: 10px;" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="赠品商品选择" prop="giftSkuId">
                            <el-button size="small" type="plain" @click="chooseGoods">选择赠品</el-button>
                            <div class="goodList" v-for="(item, key) in goodsItem" :key="key">
                                <div class="img-div">
                                    <!-- <el-image class="l" :src="item.image ? item.image : avater" alt="" /> -->
                                    <el-image style="width:80px;" :src="item.image || avater" :preview-src-list="[item.image || avater]"
                                    lazy />
                                </div>
                                <div class="r">
                                     
                                        <div class="txt-line-1 name">{{ item.giftSkuName }}</div>
                                    
                                        <div class="rr txt-line-1">{{ item.specification }}</div>
                                  
                                        <!-- <div class="rr txt-line-1">{{ item.factory }}</div> -->
                                        
                                            <div class="rr txt-line-1"> 有效期至： {{ item.expireTime ? item.expireTime.slice(0, 11)
                                                : '-' }}</div>
                                         
                                </div>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="24">
                        <el-form-item label="赠送活动配置" prop="type">
                            <div>
                                <el-radio-group v-model="formTool.type">
                                    <el-radio :key="1" :label="1">买满一定数量赠送</el-radio>
                                    <el-radio :key="2" :label="2">每买满一定数量赠送</el-radio>
                                </el-radio-group>
                                <el-button size="small" type="plain" @click="addLevel"
                                    style="margin-left: 10px;">添加阶梯</el-button>
                            </div>

                            <div v-for="(item, key) in formTool.configList" :key="key">
                                买满 <el-input size="small" v-model="item.everyQty" placeholder="" clearable
                                   style="width: 140px; margin-right: 10px;margin-left: 10px;" />
                                赠送 <el-input size="small" v-model="item.giftQty" placeholder="" clearable 
                                    style="width: 140px; margin-right: 18px;margin-left: 10px;" />
                                <el-button size="small" type="danger" icon="el-icon-delete"
                                    @click="removeLevel(key)"></el-button>
                            </div>

                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="赠品数量限制" prop="giftStock">
                            <div>
                                <!-- <el-checkbox v-model="formTool.giftStockCheck">按赠品可用库存</el-checkbox> -->
                                <el-radio-group v-model="formTool.giftStockCheck">
                                    <el-radio :key="1" :label="1">按赠品可用库存</el-radio> 
                                </el-radio-group>
                                <el-input size="small" v-model="formTool.giftStock" placeholder="" clearable
                                    style="width: 140px; margin-left: 10px;" />
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                       
                        <el-form-item label="单店赠送上限" prop="purchaseUpperCheck">
                            <div>
                                <el-input size="small" v-model="formTool.purchaseUpperLimit" placeholder="" clearable
                                    style="width: 140px; margin-left: 10px;" />
                                <el-checkbox   v-model="formTool.purchaseUpperCheck"
                                    style="margin-left: 10px;">不限</el-checkbox>
                            </div>
                            <div class="tips">
                                单个药店赠送上限：一个药店在下方设定的周期内可赠送的最高数量
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="24">
                        <el-form-item label="上限刷新周期" prop="upperLimitRefreshCycle">
                            <el-select v-model="formTool.upperLimitRefreshCycle" placeholder="请选择" size="small"
                                style="width: 400px;">
                                <el-option v-for="item in upperLimitRefreshCycle" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="上限启用时间" prop="upperLimitStartTime"> 
                            <el-date-picker v-model="formTool.upperLimitStartTime" 
                                value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="请选择"
                                size="small">
                            </el-date-picker>
                           
                        </el-form-item>
                        <div class="tips" style="margin-left: 140px;margin-bottom: 10px;">
                            上限启用时间根据周期而定：活动期内- 上架时间起生效；单笔 - 设置后立即生效；<br />
                            每天 - 设置当天00:00起效；每周 - 设置当周周一00:00起效；每月 - 设置当月1日00:00起效
                        </div>
                    </el-col>
                </el-row>
                <!-- <el-row>
                    <el-col :span="24">
                        <el-form-item label="促销详情" prop="promotionDetail">
                            <div>
                                <el-input size="small" v-model="formTool.promotionDetail" placeholder="请填写200字以内促销详情"
                                    clearable show-word-limit maxlength="200" :rows="3" type="textarea"
                                    style="width: 450px;" />
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row> -->

                <el-row>
                    <el-col :span="24">
                        <el-form-item prop="date" label="促销时间">
                            <el-date-picker style="width: 400px" v-model="formTool.date" value-format="yyyy-MM-dd HH:mm:ss"
                                :picker-options="pickerOptions" :disabled="isDisabled" type="datetimerange" size="small"
                                range-separator="-" start-placeholder="开始时间" end-placeholder="结束时间"
                                :default-time="['00:00:00', '23:59:59']" />
                            <div class="tips">
                                促销时间不得超过以下任一时间范围：原品活动时间范围、赠品活动时间范围
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="24">
                        <el-form-item label="活动图片"  >
                            <imgUpload v-model="formTool.imageList" :limit="1" :isEdit="isDisabled" />
                            <div class="tips">
                                (图片格式PNG,JPG,JPEG , 800*800px, 建议不要超过1M)。
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <div class="flex-box-bt">

                <div class="submit-btn" v-if="formTool.status == 'CHECKING' && pageType!='detail'">
                    <el-button size="small" type="primary" @click="audit('pass')">审核通过</el-button>
                </div>
                <div class="submit-btn" v-if="formTool.status == 'CHECKING' && pageType!='detail'">
                    <el-button size="small" type="plain" @click="audit('reject')">驳回</el-button>
                </div>
                <div>
                    <el-button size="small" type="plain" @click="goBack">返回</el-button>
                </div>
            </div>
        </div>
        <goodsDialog ref="goodsDialog" @didSelectItem="didSelectItem" />
        <el-dialog :visible.sync="dialogVisible" title="选择赠品" top="10vh" width="1000px" :before-close="beforeClose">
            <fullGiftClassification v-if="dialogVisible" @choice="choice" :status="formTool.status" ref="chooseGoods">
            </fullGiftClassification>
        </el-dialog>
 
        <el-dialog title="驳回原因" :visible.sync="visible" :lock-scroll="true" width="600px" :before-close="handleClose">
            <el-form ref="formTool" :model="formTool" :inline="true" style="text-align: left" label-width="140px">
                <el-row class="reject-c">
                    <el-input v-model="formTool.rejectReason" type="textarea" clearable size="small" style="width:100%"
                    placeholder="请填写50字以内驳回原因"
                        maxlength="200" />
                </el-row>
            </el-form>
            <div class="btnBox">
                <el-button size="small" @click="handleClose">取消</el-button>
                <el-button type="primary" size="small" @click="rejectSub">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import fullGiftClassification from "./components/fullGiftClassification";
import avater from "/public/img/default.png"
import imgUpload from "@/components/imgUpload";
import myTable from "@/components/myTable";
import goodsDialog from "./components/goodsDialog";
import { giftPayeeSaveOrUpdate, giftPayeeDetail, queryFullGiftPage, fullGiftAudit } from "@/api/gift";

export default {
    components: { myTable, goodsDialog, imgUpload, fullGiftClassification },
    props: {},
    data() {
        return {
            avater:avater,
            pageType: '',
            dialogVisible: false,
            pickerOptions: {
                disabledDate(date) {
                    // 如果没有后面的-8.64e7就是不可以选择今天的
                    return date.getTime() < Date.now() - 8.64e7;
                },
            },
            isDisabled: false,
            expanded: false,
            isExpanded: false,
            loading: false,
            operation: true,
            selection: true,
            index: false,
            page: {
                total: 0,
                current: 1,
                size: 10,
                pageSizes: [10, 20, 30, 50],
            },
            tableData: [],
            tableOption: [
                { label: "活动名称", prop: "promotionTitle", },
                { label: "活动时间", prop: "activeTime", slot: true, width: 330 },
                { label: "已补贴金额", prop: "activitySubsidyMoney", type: 'money' },
                { label: "参加店铺总数", prop: "storeSum", },
                { label: "参加SKU总数", prop: "skuSum", },
                { label: "活动状态", prop: "status", slot: true },
                { label: "更新人", prop: "updateBy", },
                { label: "更新时间", prop: "updateTime", },
                { label: "操作", prop: "operation", slot: true },
            ],
            upperLimitRefreshCycle: [
                {
                    label: '活动期内',
                    value: 1
                },
                {
                    label: '单笔',
                    value: 2
                },
                {
                    label: '每天 (每天00:00~24:00)',
                    value: 3
                },
                {
                    label: '每周 (周一00:00~周日24:00)',
                    value: 4
                },
                {
                    label: '每月 (每月1号00:00~每月最后一天24:00)',
                    value: 5
                }
            ],
            formTool: {
                imageList: [],
                promotionTitle: '',
                promotionDetail: '',
                giftStock: '',
                giftSkuId: '',
                type: 1,
                giftStockCheck: 1,
                // everyQty买满数量  giftQty 赠送数量
                configList: [{ everyQty: '', giftQty: '' }],
                rejectReason:''
            },
            rules: {
                promotionTitle: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
                date: [{ required: true, message: "请输入促销时间", trigger: "blur" }],
                imageList: [{ required: true, message: "请上传活动图片", trigger: "change" }],
                configList: [{ required: true, message: "请输入赠送活动配置", trigger: "blur" }],
                promotionDetail: [{ required: true, message: "请输入促销详情", trigger: "blur" }],
                giftStock: [{ required: true, message: "请输入赠品可用库存", trigger: "blur" }],
                giftSkuId: [{ required: true, message: "请选择赠品", trigger: "blur" }],
                type: [{ required: true, message: "请选择赠送活动配置", trigger: "blur" }],
                purchaseUpperCheck: [{ required: true, message: "", trigger: "blur" }],
            },
            goodsItem: [],
            visible: false,
            isDisabled:true,
        };
    },

    created() { },

    watch: {

    },
    mounted() {
        if (this.$route.query.id) {
            this.query();
        }
        if (this.$route.query.type) {
            this.pageType = this.$route.query.type;
        }
        
    },
    methods: {
        changeCheck2() {
            if (this.formTool.purchaseUpperLimit) {
                this.formTool.purchaseUpperCheck = false
            } else {
                this.formTool.purchaseUpperCheck = true
            }
        },
        query() {
            giftPayeeDetail(this.$route.query.id).then((res) => {
                if (res) {
                    this.formTool = Object.assign(this.formTool, res);
                    if (res.promotionImage) {
                        this.formTool.imageList = res.promotionImage.split(',');
                    }
                    this.formTool.date = [];
                    if (res.startTime) {
                        this.formTool.date.push(res.startTime)
                    }
                    if (res.endTime) {
                        this.formTool.date.push(res.endTime)
                    }
                    let goodsItem = [];
                    let obj = {};
                    if (res.giftSkuName) {
                        obj.goodsSkuTitle = res.giftSkuTitle;
                        obj.giftSkuName = res.giftSkuName;
                        obj.image = res.giftSkuImage;
                        obj.specification = res.giftSkuSpecification;
                        obj.factory= res.giftSkuFactory;
                        obj.expireTime = res.giftExpireTime;
                        goodsItem.push(obj)
                    }
                    this.goodsItem = goodsItem;
                   this.changeCheck2();//单店赠送上限
                }
            })
        },
        // 选择商品
        didSelectItem(e) {
            this.goodsItem = [];
            if (e) {
                this.formTool.giftSkuId = e.goodsId;
                this.goodsItem.push(e);
            }
        },
        submit() {
            let configList = this.formTool.configList;
            console.log(this.formTool, '---this.formTool')
            this.$refs['formTool'].validate((valid) => {
                if (this.formTool.configList && this.formTool.configList.length) {
                    for (let i = 0; i < configList.length; i++) {
                        if (!configList[i].everyQty) {
                            this.$message.error('请填写买满数量')
                            return
                        }
                        if (!configList[i].giftQty) {
                            this.$message.error('请填写赠送数量')
                            return
                        }

                    }
                }
                if (valid) {
                    let params = {};
                    params = Object.assign(params, this.formTool);
                    params.startTime = this.formTool.date[0];
                    params.endTime = this.formTool.date[1];
                    params.promotionImage = this.formTool.imageList.join(',');
                    giftPayeeSaveOrUpdate(params).then((res) => {
                        this.$message.success('操作成功！')
                        this.$router.back()
                    }).catch((err) => { })
                } else {

                }
            })

        },
      
        // 选择商品
        chooseGoods() { 
            this.$nextTick(() => {
                this.dialogVisible = true; 
                this.$refs['chooseGoods'].init()
            })
        },
        choice(val) {
            this.rowData.skuList = val
            // this.beforeClose()
        },
        beforeClose() {
            this.dialogVisible = false;
        },
        goBack() {
            this.$router.back()
        },
        addLevel() {
            if (this.formTool.configList.length == 20) {
                this.$message.warning('最多添加20条！')
                return
            }
            this.formTool.configList.push({ everyQty: '', giftQty: '' });
        },
        removeLevel(index) {
            if (this.formTool.configList.length == 1) {
                this.$message.warning('最少保留1条！')
                return
            }
            this.formTool.configList.splice(index, 1)
        },

        createGift() {
            let params = {};
            giftPayeeSaveOrUpdate(params).then((res) => { }).catch((err) => { })
        },
        audit(type) {
            if (type == 'pass') {
                this.$confirm(`确定要【通过】吗?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        let params = {};
                        params.id = this.formTool.id;
                        params.status = 'PASS';
                        fullGiftAudit(params).then((res) => {
                            if (res) {
                                this.$message.success('操作成功！')
                                this.$router.back()
                            }
                        }).catch((err) => { })
                    })
                    .catch(() => { });
            }
            if (type == 'reject') {
                this.visible = true;
            }
        },
        handleClose() {
            this.visible = false; 
        },
        rejectSub() {
            if (!this.formTool.rejectReason) {
                this.$message.error('请填写驳回原因！')
                return
            }
            let params = {};
            params.id = this.formTool.id;
            params.rejectReason = this.formTool.rejectReason;
            params.status = 'REJECT';
            fullGiftAudit(params).then((res) => {
                if (res) {
                    this.$message.success('操作成功！')
                    this.handleClose();
                    this.$router.back()
                }
            }).catch((err) => { })
        }
    },
};
</script>
<style lang="scss" scoped>
::v-deep.el-table {
    height: calc(100% - 138px) !important;
}

::v-deep.zt__table {
    height: calc(100% - 118px) !important;
}

::v-deep.el-table .el-table__body-wrapper {
    height: calc(100% - 78px) !important;
    overflow-y: scroll !important;
}

.expand-form {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
}

.flex-box {
    width: calc(100% - 280px);
    margin: 20px 140px;
    display: flex;
    justify-content: space-between;
    // border-top: solid 1px #eee;
    padding-top: 10px;
}

.submit-btn {
    margin: 0 10px;
}

.flex-box-bt {
    width: calc(100% - 280px);
    margin: 20px 140px;
    display: flex;
    justify-content: flex-start;
    padding-top: 10px;
}

.flex-box-lf {
    width: 100%;
    margin-top: 20px;
    display: flex;
    justify-content: flex-start;

    .title {
        line-height: 30px;
        margin-left: 20px;
    }
}

.form-content {
    margin-top: 30px;
}

.tips {
    color: #8c8c8c;
    font-size: 12px;
    margin: 0;
    // margin-left: 140px;
}

.txt-line-1 {
    line-height: 24px;
}
.img-div {
    width: 100px;
}

.goodList {
    display: flex;
    justify-content: flex-start;
}
</style>
  